import { render, staticRenderFns } from "./ListTh.vue?vue&type=template&id=33bdce8b&scoped=true&"
import script from "./ListTh.vue?vue&type=script&lang=js&"
export * from "./ListTh.vue?vue&type=script&lang=js&"
import style0 from "./ListTh.vue?vue&type=style&index=0&id=33bdce8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bdce8b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
